import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Document, Page } from 'react-pdf';
import { Layer } from "grommet";
import config from "./config";

const PDF = ({pdf, handleClose}) => {
    const [file, setFile] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => loadFile(), [])

    const loadFile = () => {
        axios.get(config.url + '/items/' + pdf.id + '/content', {responseType: 'arraybuffer'})
            .then(({data}) => {
                // let reader = new FileReader();
                // reader.onloadend = () => setFile(reader.result);
                // reader.readAsDataURL(new Blob([data]));

                setFile({data: data})
            })
            .catch(err => console.log(err))
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    console.log(file)
    return (
        <Layer onEsc={handleClose} onClickOutside={handleClose}>
            {file && <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
            </Document>}
            <div>
                <p>
                    Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                </p>
                <button
                    type="button"
                    disabled={pageNumber <= 1}
                    onClick={previousPage}
                >
                    Previous
                </button>
                <button
                    type="button"
                    disabled={pageNumber >= numPages}
                    onClick={nextPage}
                >
                    Next
                </button>
            </div>
        </Layer>
    );
}

export default PDF;